import { render, staticRenderFns } from "./ItsBaseCustomerInspect.vue?vue&type=template&id=d8beb376&scoped=true&"
import script from "./ItsBaseCustomerInspect.vue?vue&type=script&lang=js&"
export * from "./ItsBaseCustomerInspect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8beb376",
  null
  
)

export default component.exports